import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { FaGavel, FaCalendarAlt, FaUser, FaFileAlt } from 'react-icons/fa';
import Header from './Header';
import Footer from './Footer';
import { API_ENDPOINTS } from '../config/api';

const TermsAndConditions = () => {
  const [document, setDocument] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    fetchTermsAndConditions();
  }, []);

  const fetchTermsAndConditions = async () => {
    try {
      setLoading(true);
      const response = await axios.get(API_ENDPOINTS.PUBLIC_TERMS_OF_SERVICE);
      setDocument(response.data.data);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch terms and conditions:', err);
      setError(err.response?.data?.error || 'Failed to fetch terms and conditions');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <>
        <Header />
        <div className="container mt-5">
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (error) {
    return (
      <>
        <Header />
        <div className="container mt-5">
          <div className="alert alert-danger" role="alert">
            <h4 className="alert-heading">Error Loading Terms and Conditions</h4>
            <p>{error}</p>
            <hr />
            <p className="mb-0">
              Please try again later or contact support if the problem persists.
            </p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  if (!document) {
    return (
      <>
        <Header />
        <div className="container mt-5">
          <div className="alert alert-warning" role="alert">
            <h4 className="alert-heading">Terms and Conditions Not Available</h4>
            <p>No terms and conditions have been published yet.</p>
          </div>
        </div>
        <Footer />
      </>
    );
  }

  return (
    <>
      <Header />
      
      <div className="container mt-5">
        {/* Header Section */}
        <div className="row mb-5">
          <div className="col-lg-8 mx-auto text-center">
            <div style={{
              background: '#4facfe',
              padding: '3rem 2rem',
              borderRadius: '20px',
              color: 'white',
              marginBottom: '2rem'
            }}>
              <div style={{
                fontSize: '3rem',
                marginBottom: '1rem',
                opacity: '0.9'
              }}>
                <FaGavel />
              </div>
              <h1 style={{
                fontSize: '2.5rem',
                fontWeight: '700',
                marginBottom: '1rem'
              }}>
                {document.title}
              </h1>
              <p style={{
                fontSize: '1.1rem',
                opacity: '0.9',
                marginBottom: '0'
              }}>
                Understanding the terms and conditions for using our platform and services
              </p>
            </div>
          </div>
        </div>

        {/* Content Section */}
        <div className="row">
          <div className="col-lg-8 mx-auto">
            <div style={{
              background: 'white',
              padding: '2.5rem',
              borderRadius: '16px',
              boxShadow: '0 4px 20px rgba(0, 0, 0, 0.1)',
              border: '1px solid #e5e7eb'
            }}>
              <div 
                className="legal-content"
                dangerouslySetInnerHTML={{ __html: document.content }}
                style={{
                  lineHeight: '1.8',
                  fontSize: '1rem',
                  color: '#1f2937'
                }}
              />
              
              {/* Last Updated Notice */}
              <div style={{
                marginTop: '3rem',
                padding: '1.5rem',
                background: '#f8fafc',
                borderRadius: '12px',
                border: '1px solid #e5e7eb',
                textAlign: 'center'
              }}>
                <p style={{ margin: 0, color: '#6b7280', fontSize: '0.9rem' }}>
                  <strong>Last Updated:</strong> {new Date(document.updated_at).toLocaleDateString('en-US', {
                    year: 'numeric',
                    month: 'long',
                    day: 'numeric'
                  })}
                </p>
                <p style={{ margin: '0.5rem 0 0 0', color: '#6b7280', fontSize: '0.9rem' }}>
                  These terms and conditions are effective as of the date shown above.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* Contact Section */}
        <div className="row mt-5 mb-5">
          <div className="col-lg-8 mx-auto text-center">
                         <div style={{
               background: '#4facfe',
               padding: '2rem',
               borderRadius: '16px',
               color: 'white',
               marginBottom: '3rem'
             }}>
              <h3 style={{ marginBottom: '1rem' }}>Questions About These Terms?</h3>
              <p style={{ marginBottom: '1.5rem', opacity: '0.8' }}>
                If you have any questions about these terms and conditions or need clarification on any points, 
                please don't hesitate to reach out to us.
              </p>
              <a 
                href="/contact" 
                className="btn btn-primary btn-lg"
                style={{
                  fontWeight: '600',
                  padding: '0.75rem 2rem',
                  borderRadius: '8px',
                  textDecoration: 'none'
                }}
              >
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default TermsAndConditions;
